export default {
  form: {},
  sdk:  {
    me:      {},
    tabData: {},
    errors:  [],
    ready:   false,
    readyForApp:   false,
    oauth:   {
      providers: {}
    },
    ui: {
      loading:    false,
      refreshing: false,
    },
    route: {
      location: 'index',
      params:   {}
    },
    storage: {
      app:    {},
      entity: {}
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/initialState.js